import type { ThemeTokens } from "@orvis/core";

/**
 * Default dark theme — palette lifted directly from
 * `legacy/frontend/com.orvis.crc/app/constants/Theme.ts` so the new app opens
 * looking familiar to existing users.
 */
export const defaultDarkTheme: ThemeTokens = {
  background: "#121212",
  card: "#1E1E1E",
  text: "#FFFFFF",
  border: "#272727",
  primary: "#381E72",
  accent: "#BB86FC",
};
